import { Text } from '@wartek-id/text-v1'

import type { FC } from 'react'

type Props = {
  children?: React.ReactNode
}

export const DialogForm: FC<Props> = ({ children }) => {
  return (
    <div className="space-y-4">
      <Text variant="display-sm" as="h2">
        Konfirmasi data Tim Kinerja dan Pejabat Penilai Kinerja Anda
      </Text>

      {children}
    </div>
  )
}
